import GoldStarSvg from '@/assets/common/gold-star.inline.svg'
import HalfGoldStarSvg from '@/assets/common/half-gold-star-icon.inline.svg'

function StarContainer({ children }) {
  return <div className="h-4 w-4">{children}</div>
}

const GoldStar = () => {
  return (
    <StarContainer>
      <GoldStarSvg />
    </StarContainer>
  )
}

const HalfGoldStar = () => {
  return (
    <StarContainer>
      <HalfGoldStarSvg />
    </StarContainer>
  )
}

export const RatingStars = ({
  fullStars,
  hasHalfStar,
}: {
  fullStars: number
  hasHalfStar: boolean
}) => {
  return (
    <div className="flex items-center">
      {Array.from({ length: fullStars }, (_, i) => (
        <GoldStar key={i} />
      ))}
      {hasHalfStar && <HalfGoldStar />}
    </div>
  )
}
